var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('sc.gallery.uploadTitle'),
      "visible": _vm.visible,
      "width": "520px",
      "append-to-body": "",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handleClose
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.uploading,
            "disabled": _vm.previewFiles.length === 0
          },
          on: {
            "click": _vm.handleUpload
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$t('sc.gallery.confirm')) + "\n    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": _vm.uploading
          },
          on: {
            "click": _vm.handleClose
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$t('sc.gallery.cancel')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "upload-dialog-content"
  }, [_c('div', {
    staticClass: "upload-drop-zone",
    on: {
      "click": _vm.triggerFileSelect,
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.handleDrop.apply(null, arguments);
      },
      "dragover": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "upload-icon"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "plain": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('sc.gallery.selectFile')) + "\n      ")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "hidden-input",
    attrs: {
      "type": "file",
      "accept": _vm.acceptTypes,
      "multiple": ""
    },
    on: {
      "change": _vm.handleFileChange
    }
  })], 1), _vm._v(" "), _vm.previewFiles.length > 0 ? _c('div', {
    staticClass: "upload-preview"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('sc.gallery.uploadPreview')))]), _vm._v(" "), _vm._l(_vm.previewFiles, function (file, index) {
    return _c('div', {
      key: index,
      staticClass: "preview-item"
    }, [_c('div', {
      staticClass: "preview-thumb"
    }, [file.isImage ? _c('img', {
      attrs: {
        "src": file.previewUrl,
        "alt": file.name
      }
    }) : _c('div', {
      staticClass: "preview-video"
    }, [_c('i', {
      staticClass: "el-icon-video-camera"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "preview-info"
    }, [_c('div', {
      staticClass: "preview-name"
    }, [_vm._v("\n            " + _vm._s(file.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "preview-size"
    }, [_vm._v("\n            " + _vm._s(_vm.formatFileSize(file.size)) + "\n          ")]), _vm._v(" "), file.status === 'uploading' ? _c('el-progress', {
      attrs: {
        "percentage": file.progress,
        "stroke-width": 4,
        "show-text": false
      }
    }) : _vm._e(), _vm._v(" "), file.status === 'success' ? _c('span', {
      staticClass: "upload-status-success"
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]) : _vm._e(), _vm._v(" "), file.status === 'error' ? _c('span', {
      staticClass: "upload-status-error"
    }, [_c('i', {
      staticClass: "el-icon-close"
    })]) : _vm._e()], 1), _vm._v(" "), !file.status ? _c('i', {
      staticClass: "el-icon-close preview-remove",
      on: {
        "click": function ($event) {
          return _vm.removePreviewFile(index);
        }
      }
    }) : _vm._e()]);
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-folder-select"
  }, [_c('span', {
    staticClass: "folder-label"
  }, [_vm._v(_vm._s(_vm.$t('sc.gallery.selectFolder')))]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('sc.gallery.pleaseSelect'),
      "options": _vm.cleanedDirectoryTree,
      "props": _vm.cascaderProps,
      "clearable": ""
    },
    model: {
      value: _vm.selectedDirectoryId,
      callback: function ($$v) {
        _vm.selectedDirectoryId = $$v;
      },
      expression: "selectedDirectoryId"
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }